"use strict";

(function () {

    $.widget('khis.FromToList', {
        options: {
            actionCallback: null,
            noResults: ''
        },
        _create: function () {
            this.element.addClass('from_to_list');
        },
        _init: function () {

        },
        _destroy: function () {
            this.element.empty();
        },
        _drawHeader: function(w){
            var _item = $('<div data-id="'+ w.header_info.id +'" class="from_to_list_header"></div>');

            var head =    '<div class="from_to_list_sub_header">'
                        + '<span>'+ w.header_info.header_label +' </span><span class="from_to_list_header_info">'+ w.header_info.type +', </span>'+ w.header_info.execution_date + '<br />'
                        + '<span class="widget_title from_to_list_header_detail">'+ w.header_info.request_prof + ', ' + w.header_info.request_date +'</span>'
                        + '</div>';

            $(_item).append(head);

            return $(_item);
        },
        _drawDetail: function(w, item){
            var detail = '<table class="from_to_list_detail_table">';

            $.each(w.details, function(j, z){
                detail +=  '<tr>'
                         + '<td>'
                         + '<span class="from_to_list_label">'+ z.label +'</span>'
                         + '</td>'
                         + '<td>'
                         + '<span class="from_to_list_old_value">'+ z.old_value +'</span>'
                         + '</td>'
                         + '<td>'
                         + '<span>'+ z.new_value +'</span>'
                         + '</td>'
                         + '</tr>';
            });

            detail += '</table></div>';

            item.append($(detail));
        },
        _drawSummary: function(w, item){
            var summary = '<table class="from_to_list_summary_ct">';

            $.each(w.summary, function(j, z){
                summary +=  '<tr>'
                    + '<td>'
                    + '<span>'+ z.info_label + ': ' + z.info_desc +'</span>'
                    + '</td>'
                    + '</tr>';
            });

            summary += '</table></div>';

            item.append($(summary));
        },
        _drawFooter: function(w, item){
            var foot = '';
            foot += '<div class="from_to_list_footer_ct">'
                 + '<span>'+ w.footer_info.info_desc + ' ' + w.footer_info.info_date +'</span>'
                 + '</div>';

            item.append($(foot));
        },
        _drawAction: function(w, item){
            var actionString = '<div class="from_to_list_action_ct">'
                            + '<div class="from_to_list_action_header" onclick="Hades.getWorkflowActions('+ w.header_info.id +', '+ w.header_info.wf_id +', '+ w.header_info.wf_status_id +', this, {align:\'right\'}, null,'+ this.options.actionCallback +');">'
                            + '<table cellpadding="0" cellspacing="0" class="from_to_list_action_table">'
                            + '<tr>'
                            + '<td class="ui-state-highlight" >'
                            + '<div class="'+ w.header_info.wf_status_icon +' from_to_list_action_icon" data-wf-id="'+ w.header_info.wf_id +'" data-wf-status-id="'+ w.header_info.wf_status_id +'"></div>'
                            + '</td></tr></table>'
                            + '</div></div>';

            item.append($(actionString));
        },
        _drawSpacer: function(item){
            item.append($.tmpl("horizontalSpacerTpl"));
        },
        drawList: function(list){
            this.element.empty();
            var contextThis = this;
            var item;
            if (list.length <= 0){
                this.element.append($('<div class="from_to_list_no_records">'+ this.options.noResults +'</div>'));
            }

            // Iterate list
            $.each(list, function(i, w){
                item = contextThis._drawHeader(w);
                contextThis._drawDetail(w, item);
                contextThis._drawSummary(w, item);
                contextThis._drawFooter(w, item);
                contextThis._drawAction(w, item);
                contextThis._drawSpacer(item);
                contextThis.element.append(item);
            });
            contextThis.element.find('div:last-child .horizontal_spacer').remove();
        }
    });

})();